module.exports = __webpack_public_path__ + "static/media/leila1.81abda62.jpg";